import { Component } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
})
export class AppComponent {
  title = 'registro-fotografico-web';

  theme = 'grey';

  layoutMode = 'static';

  megaMenuMode = 'gradient';

  menuMode = 'dark';

  profileMode = 'top';

  inputStyle = 'outlined';

  ripple: boolean = false;

  constructor(private primengConfig: PrimeNGConfig) {}

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.ripple = true;
  }
}
